import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../layout/Index";
import { fetchProfileData } from "../redux/Apislices/authSlice";
import menu from "../layout/menu/MenuData";
import { Spinner } from "reactstrap";

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const { auth, profile } = useSelector((state) => ({
    auth: state.auth,
    profile: state.auth?.profile,
  }));

  const currentPath = window.location.pathname;

  const [available, setAvailable] = useState("idle");

  useEffect(() => {
    dispatch(fetchProfileData());
  }, [dispatch]);

  useEffect(() => {
    if (profile?.role === "admin" && profile?.permissions && menu) {
      const permissions = profile.permissions;

      const links = [];

      menu.forEach((item) => {
        if (item?.link) {
          links.push(item);
        } else if (item?.subMenu) {
          item.subMenu.forEach((subItem) => {
            if (subItem?.link) links.push(subItem);
          });
        }
        return null;
      });

      const currentLink = links.find((link) => link.link === currentPath);

      if (currentLink && permissions[currentLink.type]?.view === false) setAvailable("No");
      else setAvailable("Yes");
    } else if (profile?.role === "superadmin") {
      setAvailable("Yes");
    }
  }, [profile, currentPath]);

  return auth?.profile && ["idle", "loading", "success"]?.includes(auth?.status) && auth?.success ? (
    <Layout>
      {available === "Yes" ? (
        <Outlet />
      ) : available === "No" ? (
        <Navigate to="/" />
      ) : (
        <div
          style={{
            height: "calc(100vh - 100px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner type="grow" color="primary" />
        </div>
      )}
    </Layout>
  ) : auth?.error ? (
    <Navigate to="/auth-login" />
  ) : null;
};

export default PrivateRoute;
